import deepFreeze from '@/utils/deepFreeze'
import apiTag from '@/api/tag'
import { DEFAULT_TAG_ID } from '../../app.config'

const state = {
  tagList: [],
  status: '',
  failMsg: '',
  selectedTagId: DEFAULT_TAG_ID
}

const mutations = {
  SET_TAG_LIST (state, tagList) {
    state.tagList = deepFreeze(tagList)
  },
  SET_STATUS (state, status) {
    state.status = status
  },
  SET_FAIL_MSG (state, msg) {
    state.failMsg = msg
  },
  SET_SELECTED_TAG_ID (state, id) {
    state.selectedTagId = id
  }
}

const actions = {
  select ({ commit }, id) {
    commit('SET_SELECTED_TAG_ID', id)
  },
  getTagList ({ commit }) {
    apiTag
      .getList()
      .then(({ data: { data } }) => {
        commit('SET_TAG_LIST', data)
        commit('SET_STATUS', 'success')
      })
      .catch(({ response: { data: { message = 'Алдаа' } } }) => {
        commit('SET_STATUS', 'fail')
        commit('SET_FAIL_MSG', message)
      })
  }
}

const getters = {
  tagList: state => state.tagList.filter(({ name }) => !name.toLowerCase().includes('оператор') && !name.toLowerCase().includes('clone')),
  succeed: state => state.status === 'success',
  selectedTagId: state => state.selectedTagId,
  selectedTag: state => state.tagList.find(({ id }) => id === state.selectedTagId) || {}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
